import { StationSimple } from "@/model/StationSimple.ts";
import { PageReq, PageRes } from "@/dto/PageDto.ts";

/**
 * 충전소 리스트 조회 - req
 */
export class ReadStationListReqDto extends PageReq {}

/**
 * 충전소 리스트 조회 - res
 */
export class ReadStationListResDto extends PageRes<StationSimple> {}
